import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { createDeprecationPlan } from '../service/deprecationPlanService'
import { DeprecationPlanPayload } from '../types'
import { deprecationPlanQueryKeys } from '../queries/deprecationPlanQueryKeys'

export const useCreateDeprecationPlan = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  return useMutation({
    mutationKey: ['budget', 'deprecationPlan', 'create'],
    mutationFn: (data: DeprecationPlanPayload) => createDeprecationPlan(companyId, data),
    onSuccess: () => {
      message.success(t('messages:createSuccess', 'Created successfully'))
      // Note: Financial statements invalidation is handled by global mutation observer
      queryClient.invalidateQueries({ queryKey: deprecationPlanQueryKeys.lists() })
    },
    onError: () => {
      message.error(t('messages:createError', 'Failed to create'))
    }
  })
}
